<svg (click)="onClick()" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
  <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M26.667 28v-2.667A5.333 5.333 0 0 0 21.334 20H10.667a5.333 5.333 0 0 0-5.333 5.333V28M16 14.667A5.333 5.333 0 1 0 16 4a5.333 5.333 0 0 0 0 10.667Z"/>
</svg>

